import React from "react"

import SearchBox from "./SearchBox"
import SearchMarker from "./SearchMarker"

const MapSearchRender = (props) =>
  props.marker ? <SearchMarker {...props} /> : <SearchBox {...props} />

export default MapSearchRender
